import { render, staticRenderFns } from "./washOrder.vue?vue&type=template&id=6f9f8ed1&scoped=true"
import script from "./washOrder.vue?vue&type=script&lang=js"
export * from "./washOrder.vue?vue&type=script&lang=js"
import style0 from "./washOrder.vue?vue&type=style&index=0&id=6f9f8ed1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9f8ed1",
  null
  
)

export default component.exports